const TableWrapper = ({ children }) => {
    return (
        <div className="md:max-h-[400px] lg:max-h-[600px] xl:max-h-[900px] overflow-y-auto">
            {children}
        </div>
    );
}

export default TableWrapper;